import type { VorkommnisWert } from './VorkommnisFelder'

/** Beschwerde je Flug: Ja/Nein, leer = nicht angegeben; bei Ja ein Text (Pflicht). Aufbau wie bei den Vorkommnissen,
 *  „Ja“ in Amber. Die Werte nutzen dieselben Hilfsfunktionen wie das Vorkommnis (VorkommnisWert). */
export const beschwerdeFehler = (wert: VorkommnisWert, text: string): string | null =>
  (wert === 'JA' && !text.trim() ? 'Bitte die Beschwerde beschreiben.' : null)

export function BeschwerdeFelder({ wert, text, onChange, disabled = false }: {
  wert: VorkommnisWert
  text: string
  onChange: (wert: VorkommnisWert, text: string) => void
  disabled?: boolean
}) {
  const knopf = (v: VorkommnisWert, label: string, aktivKlasse: string) => (
    <button type="button" disabled={disabled} aria-pressed={wert === v} onClick={() => onChange(v, text)} data-testid={`beschwerde-${v === 'JA' ? 'ja' : 'nein'}`}
      className={`min-h-[44px] flex-1 rounded-xl border px-4 py-2 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
        wert === v ? aktivKlasse : 'border-dark-border text-dark-text-muted hover:bg-dark-bg-tertiary'}`}>
      {label}
    </button>
  )
  return (
    <div className="space-y-2" data-testid="beschwerde-felder">
      <label className="label">Beschwerde</label>
      <div className="flex gap-2">
        {knopf('NEIN', 'Nein – keine Beschwerde', 'border-green-500/60 bg-green-600/20 text-green-200')}
        {knopf('JA', 'Ja – Beschwerde', 'border-amber-500/60 bg-amber-600/20 text-amber-200')}
      </div>
      {wert === 'JA' && (
        <textarea value={text} onChange={e => onChange(wert, e.target.value)} disabled={disabled} rows={3}
          className="input min-h-[80px] w-full resize-y" placeholder="Worum geht es? (Pflicht bei Beschwerde)" data-testid="beschwerde-text" />
      )}
    </div>
  )
}
